export default __webpack_public_path__ + "static/media/inc-deets.44a867f4.svg";